module.exports = __webpack_public_path__ + "static/media/dashboard.c376428d.svg";